import WeatherCard from './WeatherCard';
import React from 'react';


export default function WeatherOverview() {

    return (
    <>
    <div className="Amsterdam">
       <WeatherCard city="Amsterdam" lat="52.377956" long="4.897070" />
    </div>
      <div className="Nijmegen">
      <WeatherCard city="Nijmegen" lat="51.8425" long="5.85278"/>
      </div>
</>
  );
}

